export const CONSTANTS = {
    APP_ID: 'app_id',
    PAYLOAD: 'payload',
    SESSION_EXPIRED: 'expired',
    SESSION_EXPIRY_PAGE: 'https://www.dnb.com/utility-pages/customer-portal-login.html',
    POST_LOGOUT_REDIRECT_URI: 'redirect_uri',
    POST_LOGOUT_REASON: 'reason',
    POST_LOGOUT_REFRESH_REASON: 'product_refresh',
    // prod
    OKTA_BASE_URL_PROD: 'https://sso.dnb.com',
    OKTA_ISSUER_PROD: 'https://sso.dnb.com/oauth2/ausjte6yg4e6fzj4K5d6',
    OKTA_ID_PROD: '0oa125y3f9UmAPDvz5d7',

    // stg
    OKTA_BASE_URL_STG: 'https://stg.sso.dnb.com',
    OKTA_ISSUER_STG: 'https://stg.sso.dnb.com/oauth2/auscaeiz0DjykC5321d6',
    OKTA_ID_STG: '0oapciter4JMvfTfq1d6',
    // qa
    OKTA_BASE_URL_QA: 'https://qa.sso.dnb.com',
    OKTA_ISSUER_QA: 'https://qa.sso.dnb.com/oauth2/ausg86rerPKZ500yO1d6',
    OKTA_ID_QA: '0oahn2hp4b6n3Ie531d6',

    OKTA_ID_DEV: '0oaqwuc15VzEJ330e1d6',

    // Product group for the Leaving D&B portal site
    PRODUCT_GROUP: 'THIRD_PARTY',

    // Redirect URL is coming from the  cart application(forgot password)
    REDIRECT_URL: 'redirect_url',
    SALES_CHANNEL: 'MY.DNB.COM'
};
